
import React from 'react';
import { enableStaticRendering } from 'mobx-react';
import RootStore from './root-store';
import UserStore from './user-store';
import BookingStore from './booking-store';
import ClinicStore from './clinic-store';
import PackageStore from './package-store';
import PatientStore from './patient-store';
import OptionStore from './option-store';
import EventStore from './event-store';
type CompositeStore = {
  rootStore: RootStore,
  userStore: UserStore,
  bookingStore: BookingStore,
  clinicStore: ClinicStore,
  packageStore: PackageStore,
  patientStore: PatientStore,
  optionStore: OptionStore,
  eventStore: EventStore,
};

const isServer = typeof window === "undefined";
// eslint-disable-next-line react-hooks/rules-of-hooks
enableStaticRendering(isServer);

// let _stores: null | CompositeStore = null;

const initStores = () => {
  const rootStore = new RootStore();
  const initializedStores: CompositeStore = {
    rootStore,
    userStore: rootStore.userStore,
    bookingStore: rootStore.bookingStore,
    clinicStore: rootStore.clinicStore,
    packageStore: rootStore.packageStore,
    patientStore: rootStore.patientStore,
    optionStore: rootStore.optionStore,
    eventStore: rootStore.eventStore,
  };
  return initializedStores;
};

export const stores = initStores(); // _stores || initStores();

export const StoreContext = React.createContext(stores);
// @ts-ignore
export const StoreProvider = ({ children }) => <StoreContext.Provider value={stores}>{children}</StoreContext.Provider>;
